import { apiCall, apiCallBlob, ApiResponse, apiUploadFiles } from "./apiClient";
import {
    OwnTransportOrdersQueryParameters,
    TransportOrderDetailsDto,
    TransportOrderListItemDto,
    TransportOrderUpdateDto,
} from "../models/transport/transportOrder";
import { TransportOrderSaveData } from "../models/transport/transportOrderSaveData";
import { AttachmentListItemDto } from "../models/attachment/attachment";

export const getOwnTransportOrders = (qsp: OwnTransportOrdersQueryParameters): Promise<ApiResponse<TransportOrderListItemDto[]>> => {
    return apiCall<TransportOrderListItemDto[]>("transportOrders/own", "GET", qsp);
};

export const getOpenTransportOrders = (qsp: OwnTransportOrdersQueryParameters): Promise<ApiResponse<TransportOrderListItemDto[]>> => {
    return apiCall<TransportOrderListItemDto[]>("transportOrders/openQueue", "GET", qsp);
};

export const editTransportOrderWithNotification = (
    data: TransportOrderUpdateDto,
    transportOrderId: string,
    signal?: AbortSignal
): Promise<ApiResponse<TransportOrderDetailsDto>> => {
    return apiCall<TransportOrderDetailsDto>(
        `TransportOrders/${transportOrderId}/notify?source=Mobile`,
        "PUT",
        data,
        signal
    );
};

export const updateTransportOrderEmployee = (
    transportOrderId: string,
    employeeId?: string,
    signal?: AbortSignal
): Promise<ApiResponse<TransportOrderDetailsDto>> => {
    if (employeeId) {
        return apiCall<TransportOrderDetailsDto>(
            `TransportOrders/${transportOrderId}/assign/${employeeId}`,
            "PUT",
            signal
        );
    }
    return apiCall<TransportOrderDetailsDto>(
        `TransportOrders/${transportOrderId}/assign`,
        "PUT",
        signal
    );
};

export const createTransportOrder = (
    data: TransportOrderSaveData,
    signal?: AbortSignal
): Promise<ApiResponse<TransportOrderDetailsDto>> => {
    return apiCall<TransportOrderDetailsDto>(
        "TransportOrders/mobile",
        "POST",
        data,
        signal
    );
};

export const updateTransportOrder = (
    transportOrderId: string,
    data: TransportOrderSaveData,
    signal?: AbortSignal
): Promise<ApiResponse<TransportOrderDetailsDto>> => {
    return apiCall<TransportOrderDetailsDto>(
        `TransportOrders/mobile/${transportOrderId}`,
        "PUT",
        data,
        signal
    );
};

export const deleteTransportOrder = (
    transportOrderId: string
): Promise<ApiResponse<TransportOrderDetailsDto>> => {
    return apiCall<TransportOrderDetailsDto>(
        `TransportOrders/mobile/${transportOrderId}`,
        "DELETE"
    );
};

export const getAttachmentsForTransportOrder = (id: string): Promise<ApiResponse<AttachmentListItemDto[]>> => {
    return apiCall<AttachmentListItemDto[]>(`transportOrders/${id}/files`, "GET");
};

export const downloadAttachmentForTransportOrder = (
    id: string,
    fileId: string
) => {
    return apiCallBlob(`transportOrders/${id}/files/download/${fileId}`, "GET");
};

export const deleteTransportOrderAttachment = (
    id: string,
    fileId: string
): Promise<ApiResponse<AttachmentListItemDto>> => {
    return apiCall<AttachmentListItemDto>(`transportOrders/${id}/files/delete/${fileId}?source=Mobile`, "DELETE");
};

export const addAttachmentsForTransportOrder = (
    data: FormData,
    transportOrderId: string
): Promise<ApiResponse<TransportOrderDetailsDto>> => {
    return apiUploadFiles<TransportOrderDetailsDto>(`transportOrders/${transportOrderId}/files/upload?source=Mobile`, "POST", data, null);
};
